import { render, staticRenderFns } from "./Persontipperclick.vue?vue&type=template&id=363ba4e9"
import script from "./Persontipperclick.vue?vue&type=script&lang=js"
export * from "./Persontipperclick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports